<template lang="html">
  <div text-center d-flex align-center>

    <!-- Dialog de confirmação para exclusão de um membro da equipe -->
    <c-confirm-dialog v-model="dialogConfirmaExclusao" @yes="excluirMembroEquipe()" titulo="Deseja realmente excluir o membro da equipe?">
    </c-confirm-dialog>

    <!-- Mensagem informativa sobre a carga horária dos docentes -->
    <v-layout row>
      <v-flex xs12>
        <v-alert
          class="alerta"
          color="#00796b"
          type="info"
          dense
          outlined
        >
          *Compete aos Departamentos Acadêmicos destinar carga horária às atividades de pesquisa de seus docentes (Res. 21/2013 - CEPE).
        </v-alert>
      </v-flex>
    </v-layout>

    <!-- Tabela com os participantes -->
    <v-data-table
      :headers="headers"
      :items="listaParticipantes"
      :search="search"
      :no-data-text="'Nenhum participante cadastrado.'"
      must-sort
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items-per-page="itemsPerPage"
      :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.opcoes="props">
        <div>

          <!-- Editar membro da equipe -->
          <c-tooltip-btn
          icon="edit"
          color="primary"
          tooltip="Editar membro da equipe"
          @click="toEditarParticipanteProjetoPesquisa(props.item.id)"
          :disabled="props.item.situacao === 'I'"
          disabled-tooltip='A participação do membro da equipe já foi finalizada'
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
          ></c-tooltip-btn>

          <!-- Finalizar participação do membro da equipe -->
          <c-tooltip-btn
          icon="transfer_within_a_station"
          color="primary"
          tooltip="Finalizar participação do membro da equipe"
          @click="toFinalizarParticipacaoParticipanteProjetoPesquisa(props.item.id)"
          :disabled="props.item.situacao === 'I'"
          disabled-tooltip='A participação do membro da equipe já foi finalizada'
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
          ></c-tooltip-btn>

          <!-- Excluir membro da equipe -->
          <c-tooltip-btn
          icon="delete"
          color="primary"
          tooltip="Excluir membro da equipe"
          :disabled="props.item.situacao === 'I'"
          disabled-tooltip='A participação do membro da equipe já foi finalizada'
          @click="toExcluirParticipanteProjetoPesquisa(props.item.id)"
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
          ></c-tooltip-btn>

        </div>
      </template>

      <!-- Formata carga horária semanal -->
      <template v-slot:item.cargaHorariaSemanal="props">{{ props.item.cargaHorariaSemanal === null || props.item.cargaHorariaSemanal === '' ? '-' : props.item.cargaHorariaSemanal }}</template>

      <!-- Formata data inicial -->
      <template v-slot:item.dataInicial="props">{{dates.format(props.item.dataInicial)}}</template>

      <!-- Formata data final -->
      <template v-slot:item.dataFinal="props">{{dates.format(props.item.dataFinal)}}</template>

      <!-- Número total de participantes -->
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaParticipantes.length }} {{ listaParticipantes.length > 1 ? 'membros da equipe' : 'membro da equipe' }}
      </template>

    </v-data-table>

    <br><br>

    <v-card-actions>

      <!-- Botão "Voltar" -->
      <v-btn color="primary" @click="toVoltar()">Voltar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Adicionar Membro da Equipe" -->
      <v-btn color="primary" @click="toPesquisarPessoas()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Adicionar Membro da Equipe</v-btn>

      <!-- Botão "Avançar" -->
      <v-btn color="primary" @click="toAvancar()">Avançar</v-btn>

    </v-card-actions>

  </div>
</template>

<script>
import projetos from '@/utils/projetos'
import ConfirmDialog from '@/components/c-confirm-dialog'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import TootipButton from '@/components/c-tooltip-btn'
import dates from '@/utils/dates'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
    dialogConfirmaExclusao: false,
    idParticipanteProjetoPesquisaExclusao: '',
    dates: dates,
    sortBy: null,
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    listaParticipantes: [],
    headers: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Tipo de participação', align: 'left', value: 'tipoParticipacao.descricao' },
      { text: 'CH semanal*', align: 'left', value: 'cargaHorariaSemanal' },
      { text: 'Data inicial', align: 'left', value: 'dataInicial' },
      { text: 'Data final', align: 'left', value: 'dataFinal' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Carrega os participantes do projeto de pesquisa.
    carregaParticipantesProjetoPesquisa: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando equipe...' })
      projetos.getParticipantesProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.listaParticipantes = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando equipe...' })
      })
    },

    // Edita um membro da equipe.
    toEditarParticipanteProjetoPesquisa: function (idParticipanteProjetoPesquisa) {
      this.$router.push({ name: 'EditarProjetoPesquisaMembroEquipe', params: {idProjetoPesquisa: this.idProjetoPesquisa, idParticipanteProjetoPesquisa: idParticipanteProjetoPesquisa} })
    },

    // Voltar para a aba anterior.
    toVoltar: function () {
      this.$router.push({ name: 'ProjetoPesquisaInstituicoes', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Avançar para a próxima aba.
    toAvancar: function () {
      this.$router.push({ name: 'ProjetoPesquisaOrgaosFinanciadores', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Finaliza a participação de um membro da equipe.
    toFinalizarParticipacaoParticipanteProjetoPesquisa: function (idParticipanteProjetoPesquisa) {
      this.$router.push({ name: 'FinalizarParticipacaoProjetoPesquisaMembroEquipe', params: {idProjetoPesquisa: this.idProjetoPesquisa, idParticipanteProjetoPesquisa: idParticipanteProjetoPesquisa} })
    },

    // Pesquisa por pessoas.
    toPesquisarPessoas: function () {
      this.$router.push({ name: 'ProjetoPesquisaPesquisarPessoas', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Exclui um membro da equipe (abre dialog de confirmação).
    toExcluirParticipanteProjetoPesquisa: function (idParticipanteProjetoPesquisa) {
      this.idParticipanteProjetoPesquisaExclusao = idParticipanteProjetoPesquisa
      this.dialogConfirmaExclusao = true
    },

    // Exclui um membro da equipe (chama endpoint para exclusão).
    excluirMembroEquipe: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo membro da equipe...' })
      projetos.deleteParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.idParticipanteProjetoPesquisaExclusao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaParticipantesProjetoPesquisa()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo membro da equipe...' })
      })
    }
  },
  mounted () {
    this.carregaParticipantesProjetoPesquisa()
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-tooltip-btn': TootipButton,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>

<style scoped>

  .alerta {
    margin-top: 0.5em;
    margin-bottom: 1.5em;
    margin-left: 1.0em;
    margin-right: 1.0em;
    font-size: 0.98em;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// equipe.vue?4560e088